import React, {Component} from 'react';
import {Modal} from 'antd';

class LinkConfirmDelete extends Component {
  confirm = () => {
    const {onOk, content, title, object} = this.props
    Modal.confirm({
      title: title,
      content: content,
      okText: 'Đồng ý',
      okType: 'danger',
      cancelText: 'Bỏ qua',
      onOk() {
        onOk(object)
      }
    });
  }
  render() {
    return (<span>
      <a onClick={this.confirm} style={{color: '#f04134'}}>
        Delete
      </a>
    </span>);
  }
}

export default LinkConfirmDelete;



// WEBPACK FOOTER //
// ./src/components/LinkConfirmDelete.js